import styled, { css, keyframes } from "styled-components";

const Container = ({
  children,
  className = "container",
  borderRadius = [8, 8, 8, 8],
  borderStyle = "solid",
  padding = [16, 16, 16, 16],
  margin = [0, 0, 0, 0],
  minHeight,
  flexBasis = "100%",
  display = "",
  alignItems = "",
  justifyContent = "",
  colGap = 0,
  rowGap = 0,
  flexShrink = 0,
  wrap,
  background = "",
  testId = "container",
}) => {
  return (
    <StyledContainer
      className={`${className}`}
      borderRadius={borderRadius}
      borderStyle={borderStyle}
      padding={padding}
      margin={margin}
      flexShrink={flexShrink}
      flexBasis={flexBasis}
      minHeight={minHeight}
      display={display}
      alignItems={alignItems}
      justifyContent={justifyContent}
      rowGap={rowGap}
      colGap={colGap}
      wrap={wrap}
      background={background}
      data-testid={testId}
    >
      {children}
    </StyledContainer>
  );
};

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`;

const StyledContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  animation: ${fadeIn} 400ms;
  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
  ${(props) =>
    props.padding &&
    css`
      padding-top: ${props.padding[0]}px;
      padding-right: ${props.padding[1]}px;
      padding-bottom: ${props.padding[2]}px;
      padding-left: ${props.padding[3]}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
    ${(props) =>
    props.borderRadius &&
    css`
      border-top-left-radius: ${props.borderRadius[0]}px;
      border-top-right-radius: ${props.borderRadius[1]}px;
      border-bottom-right-radius: ${props.borderRadius[2]}px;
      border-bottom-left-radius: ${props.borderRadius[3]}px;
    `}
    ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
    ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}
    ${(props) =>
    props.display === "flex" &&
    props.alignItems &&
    css`
      align-items: ${props.alignItems};
    `}
    ${(props) =>
    props.display === "flex" &&
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}
    ${(props) =>
    props.display === "flex" &&
    props.colGap &&
    css`
      column-gap: ${props.colGap}px;
    `}
    ${(props) =>
    props.display === "flex" &&
    props.rowGap &&
    css`
      row-gap: ${props.rowGap}px;
    `}
    ${(props) =>
    props.display === "flex" &&
    props.wrap &&
    css`
      flex-wrap: ${props.wrap};
    `}
    ${(props) =>
    props.flexBasis &&
    css`
      width: ${props.flexBasis};
    `}
    ${(props) =>
    props.flexShrink &&
    css`
      flex-shrink: ${props.flexShrink};
    `}
`;

export default Container;
